import React from 'react';
import { ActionButton, DialogTrigger, Flex, View } from '@adobe/react-spectrum';
import { getProjectState } from 'app/stores/project';
import { ProjectActions } from 'app/stores/project/actions';
import { isSelectionTextBased } from 'app/stores/selectors';
import { useAppDispatch } from 'app/stores/store';
import { getMarkerSizeRange, SizeIcon, } from 'app/views/components/editor/pickers/SizeIcon';
import { SizesGrid } from 'app/views/components/editor/pickers/SizesGrid';
import { TextSize } from 'app/views/components/editor/pickers/TextSize';
import { Text as CustomText } from 'app/views/components/typography/Text';
import { useConnect } from 'app/views/hooks/useConnect';
export const SizePicker = () => {
    const dispatch = useAppDispatch();
    const { color: currentColor, size: currentSize, sizes, selectionIsText, } = useConnect(state => {
        const projectState = getProjectState(state);
        return {
            color: projectState.color,
            size: projectState.size,
            sizes: state.editor.sizes,
            selectionIsText: isSelectionTextBased(state),
        };
    });
    const setSize = (size) => {
        dispatch(ProjectActions.setProperty({ property: 'size', value: size }));
    };
    const sizeRange = getMarkerSizeRange(sizes);
    const mainViewLayout = configGet('desktopMainViewLayout', 'row');
    const placement = mainViewLayout === 'row' ? 'right' : 'bottom';
    let SizePickerComponent = SizesGrid;
    if (selectionIsText && configGet('textSizePickerEnabled', false)) {
        SizePickerComponent = TextSize;
    }
    return (React.createElement(Flex, { direction: "column", alignItems: "center", justifyContent: "center" },
        React.createElement(DialogTrigger, { type: "popover", mobileType: "tray", placement: placement, hideArrow: true },
            React.createElement(ActionButton, { "data-test-id": "size-picker-trigger", isQuiet: true },
                React.createElement(SizeIcon, { size: currentSize, color: currentColor, sizeRange: sizeRange })),
            close => (React.createElement(View, { padding: "size-200" },
                React.createElement(SizePickerComponent, { color: currentColor, size: currentSize, sizes: sizes, onSelect: size => {
                        setSize(size);
                        close();
                    } })))),
        React.createElement(CustomText, { size: "XS", tag: "p" }, "Size")));
};
